module.exports = __webpack_public_path__ + "img/art3_header.890cf3af.png";